<template>
    <!--
      作者：bbc_team
      时间：2023-06-08
      描述：供货商-添加
    -->
    <div class="goods-add pb50">
        <!--添加供货商-->
        <el-form ref="form" size="small" :model="form" :rules="rules" label-width="100px">
            <div class="common-form">添加供货商</div>
            <el-form-item label="供货商名称" prop="supplier_name"><el-input v-model="form.supplier_name" placeholder="请输入供货商名称" class="max-w460"></el-input></el-form-item>
            <el-form-item label="联系人" prop="link_user"><el-input v-model="form.link_user" placeholder="请输入联系人" class="max-w460"></el-input></el-form-item>
            <el-form-item label="联系电话" prop="tel"><el-input v-model="form.tel" placeholder="请输入联系电话" class="max-w460"></el-input></el-form-item>
            <el-form-item label="供货商状态">
                <el-radio-group v-model="form.status">
                    <el-radio :label="1">正常</el-radio>
                    <el-radio :label="0">停用</el-radio>
                </el-radio-group>
            </el-form-item>
            <!--提交-->
            <div class="common-button-wrapper">
                <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
                <el-button size="small" type="primary" :loading="loading" @click="onSubmit">提交</el-button>
            </div>
        </el-form>
    </div>
</template>

<script>
import SupplierApi from "@/api/supplier.js";
    export default {
        components: {
        },
        data() {
            return {
                /*form表单数据*/
                form: {
                    supplier_id: "",
                    supplier_name: "",
                    link_user: "",
                    tel: "",
                    status: 1,
                },
                loading: false,
                /*验证规则*/
                rules: {
                    supplier_name: [{ required: true, message: "请输入供货商名称", trigger: "blur" }],
                    link_user: [{ required: true, message: "请输入联系人", trigger: "blur" }],
                    tel: [{ required: true, message: "请输入联系电话", trigger: "blur" }],

                }
            };
        },
        created() {
        },
        methods: {
            /*添加供货商*/
            onSubmit() {
                let self = this;
                let form = self.form;
                self.$refs.form.validate((valid) => {
                    if (valid) {
                        self.loading = true;
                        SupplierApi.addSupplier(form, true)
                            .then((data) => {
                                self.loading = false;
                                self.$message({
                                    message: data.msg,
                                    type: "success"
                                });
                                self.$router.push("/supplier/supplier/index");
                            })
                            .catch((error) => {
                                self.loading = false;
                            });
                    }
                });
            },

            /*取消添加，返回供货商列表*/
            cancelFunc() {
                this.$router.push({
                    path: "/supplier/supplier/index"
                });
            }
        }
    };
</script>

<style>
    .edit_container {
        font-family: "Avenir", Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
    }

    .ql-editor {
        height: 400px;
    }
</style>



// WEBPACK FOOTER //
// src/views/supplier/supplier/add.vue